import { useEffect, useState } from 'react'

import { Col, Row } from 'antd'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../reducers/UserReducer'
import PersonalHeader from '../../student/profilePage/PersonalHeader'
import PersonalSchoolInformations from '../../student/profilePage/PersonalSchoolInformations'
import PersonalInformationsForm from '../../student/profilePage/PersonalInformationsForm'
import { isObject } from '../../../utils'
import { getAssistant, getAssistantProfileImage } from '../../../utils/api/assistant'
import { resolvePromises } from '../../../utils/apiHelper'

const MIN_WINDOW_WIDTH = 900

const AssistantProfilePage = () => {
  const user = useSelector(selectUser)

  const [spanCol, setSpanCol] = useState(12)
  const [loading, setLoading] = useState(true)
  const [assistant, setAssistant] = useState({})
  const [specialityYear, setSpecialityYear] = useState({})
  const [school, setSchool] = useState({})
  const [profileImage, setProfileImage] = useState(null)

  useEffect(() => {
    const updateDimensions = () => window.innerWidth <= MIN_WINDOW_WIDTH ? setSpanCol(24) : setSpanCol(12)
    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  useEffect(() => {
    if (isObject(user)) {
      setLoading(false)
      const promisesStack = []

      promisesStack.push(getAssistantProfileImage(user, user.assistant).then(setProfileImage))
      promisesStack.push(getAssistant(user, user.assistant).then(({ data }) => {
        setAssistant(data)

        if (isObject(data.schoolSpeciality)) {
          setSchool(isObject(data.schoolSpeciality.school) ? data.schoolSpeciality.school : null)
          setSpecialityYear(isObject(data.schoolSpeciality.school) ? data.schoolSpeciality.specialityYear : null)
        }
      }))

      resolvePromises(promisesStack).then(() => setLoading(false))
    }
  }, [user.id])

  const subTitle = () => {
    const { specialityName, studyYearName } = specialityYear

    return `${specialityName} (${studyYearName})`
  }

  if (typeof assistant.id === 'undefined' || loading) {
    return <div className='loading-icon black' />
  }

  return (
    <>
      <PersonalHeader
        person={assistant}
        subTitle={subTitle}
        entityName='Assistant'
        profileImage={profileImage}
      />

      <Row span={24}>
        <Col key={0} span={spanCol} style={{ paddingRight: '5px' }}>
          <PersonalSchoolInformations school={school} person={assistant} />
        </Col>

        <Col key={1} span={spanCol}>
          <PersonalInformationsForm assistant={assistant} onChange={setAssistant} />
        </Col>
      </Row>
    </>
  )
}

export default AssistantProfilePage
